import React, { useMemo } from "react";
import SearchProvider from "./common/context/search";
import { Provider } from "urql";
import applicationClient from "./common/utils/urqlclient";
import Router from "./router";
import "./index.css";
import MlsProvider from "./mls/context/mls";
import NotificationProvider from "./common/context/notification";
import ClipboardProvider from "./common/context/clipboard";
import { Security } from "@okta/okta-react";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import { useNavigate } from 'react-router-dom';


const oktaAuth = new OktaAuth({
  issuer: 'https://newscorp.okta.com/oauth2/aus1dt9dcf8dRLApk0x8',
  clientId: process.env.REACT_APP_OKTA_CLIENT_ID || '0oa1dcis8zeaumYLq0x8',
  redirectUri: window.location.origin + '/login/callback',
  scopes: ['openid', 'profile', 'email', 'offline_access'],
  pkce: true,
  tokenManager: {
    autoRenew: true,
    autoRemove: true,
    secure: true,
    expireEarlySeconds: 30, // Refresh tokens 30 seconds before expiry
  },
});

const App: React.FC = () => {
  const navigate = useNavigate();
  const restoreOriginalUri = async (_oktaAuth: unknown, originalUri: string) => {
    // Wait for tokens to be ready before navigating
    await oktaAuth.tokenManager.get('accessToken');
    navigate(toRelativeUrl(originalUri || '/', window.location.origin));
  };

  const client = useMemo(() => {
    return applicationClient(oktaAuth);
  }, [oktaAuth]);

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <NotificationProvider>
        <Provider value={client}>
          <SearchProvider>
            <MlsProvider>
              <ClipboardProvider>
                <Router />
              </ClipboardProvider>
            </MlsProvider>
          </SearchProvider>
        </Provider>
      </NotificationProvider>
    </Security>
  );
};

export default App;